<div class="card m-2 text-center" role="region" aria-labelledby="footer-right">
    <div class="card-body d-flex justify-content-center" style="height: 200px; overflow: auto;">
        <div *ngIf="topRightLoading">
            <div class="col my-auto">
                <span class="k-icon k-i-loading kendo-loading-icon"></span>
            </div>
        </div>
        <div *ngIf="!topRightLoading">
            <app-event-list [memberId]="" [source]="'dashboard'" (total)="afterMemberCount($event)"></app-event-list>
        </div>
    </div>
    <div class="card-footer">
        <h4><span class="title-label text-uppercase" id="footer-right">{{'EVENT-STREAM' |
                translate}}</span>&nbsp;
            <span style="display: inline-flex">
                <div class="keyboard-accessible" kendoTooltip position="bottom" tabindex="0" showOn="none"
                    (focus)="showTooltip(tooltipEvents)" (mouseover)="showTooltip(tooltipEvents)" (blur)="hideTooltip()"
                    (mouseout)="hideTooltip()" aria-live="polite">
                    <a title="{{limitEventsText}}" #tooltipEvents><i class="fa fa-info-circle pointer" role="button"
                            attr.aria-label="{{'EVENT-STREAM' | translate}}"></i>
                    </a>
                </div>
            </span>
        </h4>
    </div>
</div>